import { useNativeLanguage } from "../contexts/NativeLanguageContext";

export default function LanguageChip({ className = "" }) {
  const { language, openPicker } = useNativeLanguage();
  return (
    <button
      onClick={openPicker}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gradient-to-r from-paper-deep to-gold-100 dark:from-ink-900/30 dark:to-gold-600/30 border border-ink-100 dark:border-gold-500 text-sm font-medium text-gold-700 dark:text-paper hover:from-paper-deep hover:to-gold-100 transition-all ${className}`}
      title="Change your native language"
    >
      <span className="text-base leading-none">{language.flag}</span>
      <span className="hidden sm:inline">{language.nativeName}</span>
      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
      </svg>
    </button>
  );
}
